import firebase from "../../firebase";

export default function({ officeId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "officeAdmin",
        funcName: "getPaging",
        data: { officeId }
    });
}
